export const CORPORATE_POLICY_PATH = {
  GET_BUILDER_CONFIG: "v1/organization/{0}/travel-policy-rules/builder-config/",
  GET_CORPORATE_POLICIES: "v1/organization/{0}/travel-policies/",

  GET_CORPORATE_POLICY_BY_ID: "v1/organization/travel-policies/{0}/rules/",
  CREATE_CORPORATE_POLICY: "v1/organization/{0}/travel-policies/create/",
  UPDATE_CORPORATE_POLICY: "v1/organization/{0}/travel-policies/{1}/update/",
  DELETE_CORPORATE_POLICY: "v1/organization/{0}/travel-policies/{1}/delete",
  GET_CORPORATE_POLICY_BY_USER:
    "v1/organization/travel-policies/travel-policy-by-user/{0}/",

  CREATE_CORPORATE_POLICY_RULES:
    "v1/organization/travel-policy-rules/{0}/create/",
  UPDATE_CORPORATE_POLICY_RULES:
    "v1/organization/travel-policy-rules/{0}/update/",
  DELETE_CORPORATE_POLICY_RULES:
    "v1/organization/{0}/travel-policies/{1}/rules/{2}/delete",
};
